<template>
  <bj-modal
    id="add-agents-dialog"
    v-model="addAgentDialog.visible"
    size="auto"
    title="Add agents from CSV"
  >
    <div slot="content">
      <div class="row">
        <div class="col-12 mb-4">
          Import agents from csv file:
          <input
            type="file"
            placeholder="Import agents from csv file"
            accept=".csv"
            @change="readCsvFile"
          >
        </div>
        <div class="col-12">
          <p>
            Please provide a CSV list in the following structure:
            <b>first_name,last_name,email,phone_number,market names ('|' separated):</b>
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <q-input
            v-model="csvString"
            inverted
            type="textarea"
            class="csv-input"
            :rows="4"
            @input="convertToJson"
          />
          <p
            v-if="error"
            class="text-red"
          >
            {{ error }}
          </p>
          <template v-if="agentsData.length">
            <p>Agents list:</p>
            <div class="agents-list-row-wrapper row">
              <div v-for="agent in agentsData">
                <q-tooltip
                  v-show="agent.error"
                  anchor="top left"
                  self="bottom middle"
                  :offset="[-100, 0]"
                >
                  {{ agent.error }}
                </q-tooltip>
                <q-icon
                  v-if="agent.added === undefined"
                  name="brightness_1"
                  color="gray"
                />
                <q-icon
                  v-else-if="agent.added"
                  name="brightness_1"
                  color="green"
                />
                <q-icon
                  v-else-if="!agent.added"
                  name="error"
                  color="red"
                />
                <span>{{ agent.email }}</span>
              </div>
            </div>
          </template>
        </div>
      </div>
      <div slot="footer">
        <div class="row justify-content-between">
          <div class="d-flex">
            <q-btn
              rounded
              label="Cancel"
              color="secondary"
              @click="$emit('close')"
            />
          </div>
          <div class="d-flex">
            <q-btn
              :disable="error !== null"
              rounded
              label="Add agents"
              color="primary"
              @click="addAgents"
            />
          </div>
        </div>
      </div>
    </div>
  </bj-modal>
</template>

<script>
export default {
  name: 'AddAgentsDialog',
  props: {
    addAgentDialog: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      markets: null,
      csvString: null,
      error: null,
      agentsData: [],
    };
  },
  mounted() {
    this.getMarkets().then((markets) => {
      this.markets = markets;
    });
  },
  methods: {
    readCsvFile(event) {
      const file = event.target.files[0];
      const reader = new FileReader();
      reader.onload = () => {
        this.csvString = reader.result.replace(/\r\n/g, '\n');// make sure crlf converted to lf
        this.convertToJson();
      };
      reader.readAsText(file);
    },
    convertToJson() {
      const tempAll = this.csvString;
      const tempRows = tempAll.split(new RegExp('\\n'));

      const arrayOfAgents = [];

      tempRows.forEach((row) => {
        const arrFromRow = row.split(csvDelimiter);
        if (arrFromRow.length % 5 === 0) {
          const splitRow = row.split(csvDelimiter);
          arrayOfAgents.push(Array.from({ length: Math.ceil(splitRow.length / 5) }, (v, i) => splitRow.slice(i * 5, i * 5 + 5)));
          this.error = null;
        } else {
          this.error = 'Please, check the structure, some rows are incomplete';
          return false;
        }
      });

      this.mapAgentsData(arrayOfAgents.flat(1));
    },
    mapAgentsData(array) {
      this.agentsData = array.map((agent) => ({
        first_name: agent[0],
        last_name: agent[1],
        email: this.validateEmail(agent[2]),
        phone_number: this.trimAndValidatePhone(agent[3]),
        markets: this.collectMarkets(agent[4]),
        added: undefined,
      }));
    },
    validateEmail(email) {
      if (!this.$config.emailRegex.test(email)) {
        this.error = `Email: ${email} is not valid`;
      } else {
        return email;
      }
    },
    trimAndValidatePhone(phone) {
      const trimmedPhone = phone.replace(/[^0-9+]/g, '');
      if (!this.$config.phoneNumberRegex.test(trimmedPhone)) {
        this.error = `Phone: ${trimmedPhone} is not valid`;
      } else {
        return trimmedPhone;
      }
    },
    collectMarkets(marketsArr) {
      const arrOfMarketNames = marketsArr.split(csvSeparator);
      const arrOfMarketIds = [];
      const invalidMarketNames = [];
      arrOfMarketNames.forEach((marketName) => {
        const market = this.resolveMarketFromName(marketName);
        if (market) {
          arrOfMarketIds.push(market.id);
        } else {
          invalidMarketNames.push(marketName);
        }
      });
      if (invalidMarketNames.length !== 0) {
        this.error = `Not valid markets: ${invalidMarketNames.join(', ')}`;
      }
      return arrOfMarketIds;
    },
    resolveMarketFromName(marketName) {
      return this.markets.find(((market) => market.name.toLowerCase() === marketName.toLowerCase()));
    },
    addAgents() {
      this.createAgent(0);
    },
    createAgent(index) {
      if (index === this.agentsData.length) {
        return;
      }
      return new Promise(() => {
        this.api().request('POST', 'admin/agents', this.agentsData[index])
          .then(
            () => {
              this.agentsData[index].added = true;
              this.createAgent(index + 1);
            },
            (error) => {
              this.agentsData[index].added = false;
              this.agentsData[index].error = this.getFirstError(error) || error.message;
            },
          );
      });
    },
  },
};
const csvDelimiter = ',';
const csvSeparator = '|';
</script>

<style lang="scss" scoped>
    .agents-list-row-wrapper {
        div {
            flex: 25%;
            margin-bottom: 1rem;
        }

        span {
            margin-left: 0.5rem;
        }
    }

    .csv-input {
        margin: 1rem 0;
    }
</style>
